// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8054":"f7bd8413","9701":"248bea86"}[chunkId] + ".chunk.css";
};